import React, { Component } from 'react';

export default class BooleanRenderer extends Component {
  state = {
    value: this.props.value,
  }

  refresh(params) {
    if (params.value !== this.state.value) {
      this.setState({ value: params.value })
    }
    return true;
  }

  renderCell = () => {
    const { value } = this.state;

    if (value === null || typeof value === 'undefined') {
      return <span className="finmatek-boolean-pill finmatek-boolean-pill--empty">—</span>;
    }

    const isTrue = value === true || value === 'true' || value === 1 || value === '1';
    const neutral = Boolean(this.props.neutral);
    const inverse = Boolean(this.props.inverse);
    const isPositive = inverse ? !isTrue : isTrue;

    if (neutral) {
      return (
        <span className="finmatek-boolean-pill finmatek-boolean-pill--neutral">
          {isTrue ? 'Yes' : 'No'}
        </span>
      );
    }

    return (
      <span className={`finmatek-boolean-pill ${isPositive ? 'finmatek-boolean-pill--true' : 'finmatek-boolean-pill--false'}`}>
        <span className="finmatek-boolean-pill__icon">{isPositive ? '✓' : '×'}</span>
        {isTrue ? 'Yes' : 'No'}
      </span>
    );
  }

  render() {
    return this.renderCell();
  }
}
